import "@bower_components/select2/dist/css/select2.css";
import "select2-bootstrap-theme/dist/select2-bootstrap.css";


import '../styles/admin.scss';

import './admin/map.js';
import './admin/stats.js';
import URI from 'urijs';
import moment from 'moment';

import '../styles/admin/quill_snow.css';
import Quill from 'quill';

import sortable_inline from './admin/sortable_inline';
import ceo_content_copy from './admin/copy_ceo';
import other_location from './admin/other_location';
require('@bower_components/moment/locale/de');
window.moment = moment;
window.$ = window.jQuery;

const SIMPLE_TOOLBAR_CONFIG = [
  ['bold', 'italic', 'underline', 'link'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['clean']
];



window.addEventListener('load', () => {
  try {
    if ($('#brief_info').length) {
      // Add Quill initialization
      var quillDiv = document.createElement('div');
      quillDiv.id = 'quill_brief_info';
      $('#brief_info').after(quillDiv);

      // Hide the original textarea
      $('#brief_info').hide();

      // Initialize Quill
      var quill = new Quill('#quill_brief_info', {
        modules: {
          toolbar: SIMPLE_TOOLBAR_CONFIG
        },
        theme: 'snow'
      });

      // Set initial value from textarea
      quill.root.innerHTML = $('#brief_info').val();

      // Handle form submission
      document.querySelector('.admin-form').onsubmit = function () {
        document.getElementById('brief_info').value = quill.root.innerHTML;
      };
    }
  } catch (ReferenceError) {

  }

  $('.ticket-line').click(function (e) {
    // state
    var state = $(this).is('.ticket-show-details'); // true == shown

    // reset all
    $('.ticket-detail').addClass('hidden');
    $('.ticket-line').removeClass('ticket-show-details');

    // load current url for manipulation
    var url = new URI();

    if (!state) {
      // show
      $(this).addClass('ticket-show-details');

      var next = $(this).next();
      next.removeClass('hidden');

      // add active state to all urls
      url.query['ticket_shown'] = $(this).attr('data-ticket-id');

      $('.task-edit-btn').each(function () {
        var editUrl = $(this).attr('href');
        editUrl = new URI(editUrl);
        editUrl.query['url'] = url.path + '?' + url.query;
        $(this).attr('href', editUrl);
      });

    } else {
      delete url.query['ticket_shown'];
    }

    // push changed url
    history.replaceState(null, null, url);
  });

  $('.ticket-line a').click(function (e) {
    e.stopImmediatePropagation();
  });

  $('.task-line').click(function (e) {
    if ($(e.originalEvent.target).is('.task-edit-btn') ||
      $(e.originalEvent.target).parent().is('.task-edit-btn')) {
      return;
    }

    // state
    var state = $(this).is('.task-show-details'); // true == shown
    // reset all
    $('.task-detail').addClass('hidden');
    $('.task-line').removeClass('task-show-details');

    // load current url for manipulation
    var url = new URI();

    if (!state) {
      // show
      $(this).addClass('task-show-details');

      var next = $(this).next();
      next.removeClass('hidden');

      // add active state to all urls
      url.query['task_shown'] = $(this).attr('data-task-id');

      $('.task-edit-btn').each(function () {
        var editUrl = $(this).attr('href');
        editUrl = new URI(editUrl);
        editUrl.query['url'] = url.path + '?' + url.query;
        $(this).attr('href', editUrl);
      });

    } else {
      delete url.query['task_shown'];
    }

    // push changed url
    history.replaceState(null, null, url);
  });

  $('.task-line a:not(".task-edit-btn")').click(function (e) {
    e.stopImmediatePropagation();
  });


  $('#ChangeUser').change(function () {
    var username = $(this).val();
    window.location = $(this).data('url') + username;
  });


  sortable_inline();
  ceo_content_copy();
  other_location();

  function toggleTerminationDate() {
    var has_termination_date = $('#has_termination_date');
    var termination_date = $('#termination_date');
    var is_terminating_and_reserved = $('#is_terminating_and_reserved');
    var val = termination_date.val();

    if (val) {
      termination_date.parent().parent().show();
      is_terminating_and_reserved.parent().parent().show();
      has_termination_date.attr('checked', true);
    } else {
      termination_date.parent().parent().hide();
      is_terminating_and_reserved.parent().parent().hide();
      has_termination_date.attr('checked', false);
    }

    has_termination_date.on('change', function () {
      if (this.checked) {
        termination_date.parent().parent().show();
        is_terminating_and_reserved.parent().parent().show();
      } else {
        termination_date.parent().parent().hide();
        is_terminating_and_reserved.parent().parent().hide();
      }
    });
  }

  function togglebMeter(meter, note) {
    var val = meter.attr('checked');

    if (val) {
      note.parent().parent().show();
    } else {
      note.parent().parent().hide();
    }

    meter.on('change', function () {
      if (this.checked) {
        note.parent().parent().show();
      } else {
        note.parent().parent().hide();
      }
    });
  }


  $('#fa_modal_window').on('shown.bs.modal', function (e) {
    togglebMeter($('#has_external_electric_meter'), $('#external_electric_meter_note'));
    togglebMeter($('#has_sub_electric_meter'), $('#sub_electric_meter_note'));
    togglebMeter($('#has_water_meter'), $('#water_meter_note'));
    togglebMeter($('#has_heating_meter'), $('#heating_meter_note'));
    togglebMeter($('#has_air_conditioning_meter'), $('#air_conditioning_meter_note'));
    togglebMeter($('#has_process_cooling_meter'), $('#process_cooling_meter_note'));

    toggleTerminationDate();

  }).on('hidden.bs.modal', function () {
    $('#has_external_electric_meter').off();
    $('#has_sub_electric_meter').off();
    $('#has_water_meter').off();
    $('#has_heating_meter').off();
    $('#has_air_conditioning_meter').off();
    $('#has_process_cooling_meter').off();

    $('#has_termination_date').off();
  });


  function toggleFormGroup() {
    let $el = $(this);
    let $target = $($el.data('target')).parents('.form-group');

    if ($target.has('.check-and-hide')) {
      $target.addClass('check-and-hide');
    }

    setTimeout(() => {
      $target.toggleClass('hide', !$el.is(':checked'));
    }, !$el.is(':checked') ? 300: 0 );

    setTimeout(() => {
      $target.toggleClass('check-and-hide--hidding', !$el.is(':checked'));
    }, $el.is(':checked') ? 300 : 0);
  }

  $('.form-group').on('change', 'input[data-toggle="check-and-hide"]', toggleFormGroup);
  $('input[data-toggle="check-and-hide"]').each(toggleFormGroup);

  $('#fa_filter').keyup(function () {
    var rex = new RegExp($(this).val(), 'i');
    $('.searchable tr').hide();
    $('.searchable tr').filter(function () {
      return rex.test($(this).text());
    }).show();
  });

  var VersionsData = $('#VersionsData');
  if (VersionsData.length) {
    var url = VersionsData.data('versions');

    function renderSalute(value) {
      switch (parseInt(value)) {
        case 1:
          return 'Herr';
          break;
        case 2:
          return 'Frau';
          break;
        default:
          return 'Keine';
      }
    }

    function renderValue(value, key) {
      if (key == 'salute') {
        return renderSalute(value);
      }

      if (key == 'title' && !value) {
        return 'Kein Titel';
      }

      if (value === null) {
        return '[Leer]';
      }

      if (value === false) {
        return 'Nicht gesetzt';
      }

      if (value === true) {
        return 'Gesetzt';
      }

      return value;
    }

    function appendValues(container, key, value, versionTyp) {
      const [before, after] = value;
      if (key != 'id') {
        container.append(
          `<div class="col-md-offset-2 col-md-10 version-box ${versionTyp}"><div class="version version-before version-field-${key} ">${renderValue(before, key)}</div><div class="version version-after version-field-${key} ">${renderValue(after, key)}</div></div>`
        );
      }
    }

    function renderContactsVersion(version, versionTyp) {
      const { changes, id } = version;
      let outerContainer = $(`[name^="contacts-"][name$="-id"][value="${id}"]`).parent();

      $.each(changes, (key, value) => {
        let container = outerContainer.find(`[name$="${key}"]`).parentsUntil('.inline-form-field', '.form-group');
        appendValues(container, key, value, versionTyp);
      });
    }

    function renderNumbersVersion(version, versionTyp) {
      const { changes, id } = version;
      let outerContainer = $(`[name^="emergency_numbers-"][name$="-id"][value="${id}"]`).parent();

      $.each(changes, (key, value) => {
        let container = outerContainer.find(`[name$="${key}"]`).parentsUntil('.inline-form-field', '.form-group');
        appendValues(container, key, value, versionTyp);
      });
    }

    function renderVersion(version, versionTyp) {
      const { changes, contacts, numbers } = version;
      $.each(changes, (key, value) => {
        let container = $(`[name="${key}"]`).parents('.form-group');
        appendValues(container, key, value, versionTyp);
      });

      $.each(contacts, (index, value) => renderContactsVersion(value, versionTyp));
      $.each(numbers, (index, value) => renderNumbersVersion(value, versionTyp));

    }

    function renderVersions(data) {
      const { results } = data;
      renderVersion(results['tzs-import'], 'version-tzs-import');
      renderVersion(results['xls-import'], 'version-xls-import');
    }

    $.getJSON(url, renderVersions);

    $('#VersionTZS').click(function() {
      $(this).toggleClass('active');
      $('.version-tzs-import').toggleClass('active', $(this).is('.active'))
    });

    $('#VersionXLS').click(function () {
      $(this).toggleClass('active');
      $('.version-xls-import').toggleClass('active', $(this).is('.active'))
    });

  }
});
